import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { formatDateTime } from "@/lib/format";

interface AuditCellProps {
  createdAt: string;
  createdBy?: string | null;
  updatedAt: string;
  updatedBy?: string | null;
}

function ActorBadge({ actorId }: { actorId: string | null | undefined }) {
  if (!actorId) return <span className="text-muted-foreground">—</span>;

  return (
    <Link to={`/users/${actorId}`}>
      <Badge variant="secondary" className="font-mono text-xs hover:bg-primary/20 cursor-pointer">
        {actorId.slice(0, 8)}...
      </Badge>
    </Link>
  );
}

export function AuditCell({ createdAt, createdBy, updatedAt, updatedBy }: AuditCellProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="text-left text-sm text-muted-foreground hover:text-foreground hover:underline underline-offset-2 decoration-dotted cursor-pointer">
          {formatDateTime(updatedAt)}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64">
        <div className="space-y-3">
          <div>
            <p className="text-xs font-medium text-muted-foreground mb-1">Created</p>
            <p className="text-sm">{formatDateTime(createdAt)}</p>
            <div className="mt-1 flex items-center gap-1.5">
              <span className="text-xs text-muted-foreground">by</span>
              <ActorBadge actorId={createdBy} />
            </div>
          </div>
          <div className="border-t pt-3">
            <p className="text-xs font-medium text-muted-foreground mb-1">Updated</p>
            <p className="text-sm">{formatDateTime(updatedAt)}</p>
            <div className="mt-1 flex items-center gap-1.5">
              <span className="text-xs text-muted-foreground">by</span>
              <ActorBadge actorId={updatedBy} />
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
